import React from 'react'
import {
    Navigate
} from 'react-router-dom';
import useAuthStore from '../store/auth';

export default function IsLawyerProfile({
    children
}) {
    
    const user = useAuthStore((state) => state.user);
    return user.role === 1 ? children : <Navigate to = "/account/dashboard" state = { { redirectFrom: '' } } />
}